import axios from "axios";

axios.defaults.validateStatus = () => true;

export async function getBikePorChassi(
  url: string,
  CHASSI: string,
  MARCA: string,
  ID_BIKE: string
) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = await axios.get(
    `${url}/alertaBike/buscarPorChassi/?chassi=${CHASSI}&marca=${MARCA}&id_bike=${ID_BIKE}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}

export async function getFotoDaBike(url: string, ID_BIKE: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = await axios.get(`${url}/alertaBike/buscarFoto/${ID_BIKE}`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
  return response;
}
